import { render, staticRenderFns } from "./indexb.vue?vue&type=template&id=f35ea0b4&scoped=true"
import script from "./indexb.vue?vue&type=script&lang=js"
export * from "./indexb.vue?vue&type=script&lang=js"
import style0 from "./indexb.vue?vue&type=style&index=0&id=f35ea0b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35ea0b4",
  null
  
)

export default component.exports